// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1m-pq","modalForm":"UpgradeEpcsModal_modalForm__u0IKA","modalFooter":"UpgradeEpcsModal_modalFooter__22HYi"};